<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="(val) => $emit('update:is-drawer-open', val)"
  >
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link
        to="/admin-dashboard"
        class="d-flex align-center text-decoration-none"
        @click.native="reloadPage"
      >
        <v-img
          :src="require('@/assets/images/logos/logo_4_small_bustracker.png')"
          max-height="30px"
          max-width="30px"
          alt="logo"
          contain
          eager
          class="app-logo me-3"
        ></v-img>
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
            {{ systemName }}
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>

    <!-- Navigation Items -->
    <v-list expand shaped class="vertical-nav-menu-items pr-5 nav-list-bottom">
      <nav-menu-link
        title="Dashboard"
        :to="{ name: 'admin-dashboard' }"
        :icon="icons.mdiHomeOutline"
        color="#e65100"
      ></nav-menu-link>
      <nav-menu-section-title title="Organisations"></nav-menu-section-title>
      <nav-menu-link
        title="Organisations"
        :to="{ name: 'organisations' }"
        icon="mdi-domain"
        color="#1976D2"
      ></nav-menu-link>
      <nav-menu-link
        title="Bluetooth tags"
        :to="{ name: 'admin-student-tags' }"
        icon="mdi-bluetooth"
        color="#00838F"
      ></nav-menu-link>
      <nav-menu-section-title title="Demo"></nav-menu-section-title>
      <nav-menu-link
        title="Demo statistics"
        :to="{ name: 'demo-statistics' }"
        icon="mdi-chart-box-outline"
        color="#0097A7"
      ></nav-menu-link>
      <nav-menu-section-title title="SETTINGS"></nav-menu-section-title>
      <nav-menu-link
        title="Settings"
        :to="{ name: 'settings' }"
        icon="mdi-cog"
        color="#388E3C"
      ></nav-menu-link>
      <nav-menu-link
        title="Privacy Policy"
        :to="{ name: 'privacy-policy' }"
        icon="mdi-shield-account"
        color="#7B1FA2"
      ></nav-menu-link>
      <nav-menu-link
        title="Terms & Conditions"
        :to="{ name: 'terms-and-conditions' }"
        icon="mdi-file-document-outline"
        color="#F57C00"
      ></nav-menu-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiMapMarkerPath,
  mdiCrosshairsGps,
} from '@mdi/js';
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue';
import NavMenuGroup from './components/NavMenuGroup.vue';
import NavMenuLink from './components/NavMenuLink.vue';
import { Keys } from '/src/config.js';

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
    Keys,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiMapMarkerPath,
        mdiCrosshairsGps,
      },
      systemName: Keys.VUE_APP_SYSTEM_NAME,
    };
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

.app-logo {
  transition: all 0.18s ease-in-out;
  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.nav-list-bottom {
  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px)) !important;
}
</style>
